import { API, IdUser } from "./apiConfig";

export const getUserData = () => {
    const data = {
        IdUser
    }
    return API.post('/UnitManagement/Dashboard', data)
}